import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import TreeCategoryAutocomplete from '../TreeCategoryAutocomplete';
import type { Category } from '../../../types';
import type { OperationColumnFilters } from './types';

interface DescriptionFilterContentProps {
  categories: Category[];
  value: OperationColumnFilters['description'];
  onChange: (next: OperationColumnFilters['description']) => void;
}

export default function DescriptionFilterContent({
  categories,
  value,
  onChange,
}: DescriptionFilterContentProps) {
  const { t } = useTranslation('operations');

  return (
    <div className="space-y-2 w-[260px]">
      <div>
        <label className="block text-xs font-medium text-gray-500 mb-1">
          {t('filters.category')}
        </label>
        <div className="flex items-center gap-1">
          <div className="flex-1 min-w-0">
            <TreeCategoryAutocomplete
              categories={categories}
              categoryId={value.categoryId}
              subcategoryId={value.subcategoryId}
              onChange={(categoryId, subcategoryId) =>
                onChange({ ...value, categoryId, subcategoryId })
              }
              allowCreate={false}
              placeholder={t('filters.categoryPlaceholder')}
            />
          </div>
          {value.categoryId && (
            <button
              type="button"
              onClick={() => onChange({ ...value, categoryId: '', subcategoryId: '' })}
              className="p-1 text-gray-400 hover:text-gray-600"
              title={t('filters.clear')}
            >
              <X className="w-3.5 h-3.5" />
            </button>
          )}
        </div>
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-500 mb-1">
          {t('filters.text')}
        </label>
        <input
          type="text"
          className="input py-1.5 text-sm w-full"
          value={value.text}
          onChange={(e) => onChange({ ...value, text: e.target.value })}
          placeholder={t('filters.textPlaceholder')}
        />
      </div>
    </div>
  );
}
